import { defineComponent, reactive, ref } from "vue";
export default defineComponent({
  name: "tagNav",
  props: {
    tagNav: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /* 是否显示热门和全部 */
    isShow: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    /* 右边标签 */
    var rightTag = reactive([{
      id: "new",
      title: "全部"
    }, {
      id: "hot",
      title: "热门"
    }]);
    var isTitle = ref(0);
    var isTag = ref("0"); //存储左边标签

    var isRightTag = ref("new"); //存储右边标签

    /* 切换标签事件 */

    var tagChangeClick = function tagChangeClick(id, title) {
      if (isTag.value != id) emit("tagChangeClick", id, isRightTag.value);
      isTitle.value = title;
      isTag.value = id;
    };
    /* 右边标签切换事件,id就是string */


    var rightTagClick = function rightTagClick(id) {
      if (isRightTag.value != id) emit("rightTagClick", String(isTag.value), id);
      isRightTag.value = id;
    };

    return {
      isTag: isTag,
      isRightTag: isRightTag,
      isTitle: isTitle,
      rightTag: rightTag,
      tagChangeClick: tagChangeClick,
      rightTagClick: rightTagClick
    };
  },
  components: {}
});